import { createRouter, createWebHistory} from "vue-router";

const home = () => import("../pages/Home");
// const countdown = () => import("../pages/CountDown");
const records = () => import("../pages/Records");
const register = () => import("../pages/Register");
const registerRecords = () => import("../pages/RegisterRecords");
const referral = () => import("../pages/Referral");
const match = () => import("../pages/Match");
const campaign = () => import("../pages/Campaign");
const notFound = () => import("../pages/404");

const routes = [
  {
    path: '/',
    name: "index",
    component: home,
  },
  {
    path: '/campaign',
    name: "campaign",
    component: campaign,
    meta: {
      title: 'Campaign',
    }
  },
  {
    path: '/records',
    name: "records",
    component: records,
    meta: {
      title: 'Records',
    }
  },
  {
    path: '/register',
    name: "register",
    component: register,
    meta: {
      title: 'Register',
    }
  },
  {
    path: '/register_records',
    name: "register records",
    component: registerRecords,
    meta: {
      title: 'Register Records',
    }
  },
  {
    path: '/referral',
    name: "referral",
    component: referral,
    meta: {
      title: 'Referral',
    }
  },
  {
    path: '/match',
    name: "match",
    component: match,
    meta: {
      title: 'Match',
    }
  },
  { 
    path: '/:pathMatch(.*)*', 
    name: 'notFound', 
    component: notFound,
    meta: {
      title: 'NOT FOUND',
    }
  }
]

const router = createRouter({
  history: createWebHistory(),
  linkActiveClass:'active-link',
  routes: routes
})

export default router;